import { Heading } from "@jobber/components/Heading";
import React, { useEffect, useState } from "react";
import { putToServer } from "./requests";
import { showToast } from "@jobber/components/Toast";
import { useDispatch, useSelector } from "react-redux";
import { setUserTags } from "../../store/tagsSlice";
import { Checkbox } from '@jobber/components/Checkbox';
import { StatusLabel } from '@jobber/components/StatusLabel';

const EditableText = ({ initialText, des, isExclusive, id, isEditing, cancelEditing, setSaveHandler, setLoading, save, onClick, numberOfTags }) => {
  const dispatch = useDispatch();
  const tagSlice = useSelector((store) => store.tag);
  const [text, setText] = useState(initialText);
  const [desInput, setDes] = useState(des);
  const [exclusive, setExclusive] = useState(isExclusive);
  // const [isEditing, setIsEditing] = useState(false);

  const handleChange = (e) => {
    setText(e.target.value);
  };

  useEffect(() => {
    if (save == true) {
      onBlurhandler()
    }
  }, [save])

  // const toggleEdit = () => {
  //   setIsEditing(!isEditing);
  // };

  const onBlurhandler = async () => {
    const result = await putToServer(`tags/${id}`, { categoryName: text, description: desInput, isExclusive: exclusive });
    if (result.status) {
      cancelEditing()
      setSaveHandler(false)
      setLoading(false)
      showToast({ message: "Category updated", variation: "success" });
      const newData = tagSlice?.userTags?.map((s) => {
        if (s._id === id) return { ...s, categoryName: text, description: desInput, isExclusive: exclusive };
        else return s;
      });
      dispatch(setUserTags(newData));
    } else {
      showToast({
        message: result.message || result.error,
        variation: "error",
      });
    }
  };

  return (
    <div>
      {isEditing ? (
        <>
          <input
            type="text"
            value={text}
            className="form-control"
            onChange={handleChange}
            autoFocus
          />
          <input
            type="text"
            value={desInput}
            className="form-control mt-2"
            placeholder="Description"
            onChange={(e) => setDes(e.target.value)}
          />
          <div className="mt-2">
            <Checkbox
              checked={exclusive}
              onChange={(newValue) => setExclusive(newValue)}
              label="Exclusive"
            />
          </div>
        </>
      ) : (
        <span onClick={onClick} className="pointer d-flex align-items-center gap-2">
          <Heading level={4}>{text}</Heading>
          {numberOfTags > 0 && <div>
            ({numberOfTags})
          </div>
          }
          {isExclusive && <StatusLabel label="Excl." status="informative" />}
        </span>
      )}
    </div>
  );
};

export default EditableText;
